import type { ApiName, ApiResource } from './types';
import type { ExternalChainExtended } from 'types/externalChains';

import config from 'configs/app';

import type { ResourceName } from './resources';
import { RESOURCES } from './resources';

export default function getResourceParams(resourceFullName: ResourceName, chain?: ExternalChainExtended) {
  const [ apiName, resourceName ] = resourceFullName.split(':') as [ApiName, string];
  // console.log(apiName, "----chain---", config)
  const apiConfig = (() => {
    if (chain?.app_config?.apis) {
      return chain.app_config.apis[apiName as keyof typeof chain.app_config.apis];
    }

    // console.log(apiName, "----chain---", config.apis[apiName])
    return config.apis[apiName];
  })();

  if (!apiConfig) {
    throw new Error(`API config for ${ apiName } not found`);
  }

  // fetch("https://xhaviscan.com/api/v2/main-page/transactions")
  //   .then(res => res.json())
  //   .then(data => console.log("data........", data))
  //   .catch(err => console.error(err));

  return {
    api: apiConfig,
    apiName,
    resource: RESOURCES[apiName][resourceName as keyof typeof RESOURCES[ApiName]] as ApiResource,
  };
}
